import {z} from 'zod';
import {ObjectIdSchema} from '../zod';
import {zodTypeguard} from '../api/helpers';

export const GenerateAgentStateSchema = z.object({
  agentId: ObjectIdSchema.optional(),
});
export type GenerateAgentState = z.infer<typeof GenerateAgentStateSchema>;
export const isGenerateAgentState = zodTypeguard(GenerateAgentStateSchema);
